import axios from 'axios';
import { Message } from 'element-react';
let requestUrl= "https://zk.dgjapp.com"; //https://dgjapp.picp.vip  https://pddmobile.dgjapp.com
// let tokens=Token;
// console.log(tokens);
let zhuKeToken="";//54CE4081AAE0AFEA121A0FA63D7E0AEA
let zhuKeShopName="";


let zhuKeTaoteId = '';
let zhuKeTaoteShopName = '';

let loginShopId="";//平台店铺的id
let loginOutShopId="";//平台店铺外部店铺id
let loginShopName="";//平台店铺的名称
let loginShopPlatformType="";//平台店铺的平台
let loginShopPayUrl="";//平台店铺的订购链接，在没有绑定阿里时，需要这个链接
let loginShopExpiredDay="";//平台店铺的订购,有效期剩余时间
let funSplitTypeNumber =2;
let isLoadSystemData =false;

/** 
 * 系统配置相关
 */
export const systemConfig =
{
  requestUrl : 'https://zk.dgjapp.com',//正式环境
  initTokenRequestUrl:"https://zk.dgjapp.com",
  platformType:'',
  alibabaShopId:'',//阿里巴巴shopid
  ContactWayList:[],
  QQContactWay:undefined,//QQ联系方式
  isShowNoticeImg:true,
  requestExternalUrl : 'https://www.dgjapp.com',//请求店管家后台接口https://www.dgjapp.com   http://192.168.1.72:30002
  isZk1:()=>{
    return systemConfig.serverLink().indexOf('zk1') > -1;
  },
  isZk5:()=>{
    //return false;
    return systemConfig.serverLink().indexOf('zk5') > -1;
  },
  serverLink:()=>{//这里更换请求连接
    return systemConfig.requestUrl;
  },
  isTouTiao:()=>{
    return systemConfig.platformType == "TouTiao"
  },
  isKuaiShou:()=>{
    return systemConfig.platformType == "KuaiShou"
  }
}

//本地调试，就放开这个，注释下面的Fetchs 方法
export const requests =(options) => {
  let url=urls(options.url);
  const shoptoken = localStorage.getItem("hasZhukeLoginShopTokens") || ''
  if(options.url && options.url.indexOf('/Auth/GetZhuKeTokenByShopInfo') > -1 || options.url.indexOf('/Auth/GetZhuKeCommAlibabaByAlone') > -1)
    url = systemConfig.initTokenRequestUrl + options.url
  else if(options.shopType === true)
    url = systemConfig.initTokenRequestUrl + options.url + '?shopToken=' + shoptoken
  

  return axios.post(url,options.data).then((res) => {
    var dates =res.data;
    options.success(dates)

  }).catch(err=> {if(options.fail) options.fail(err) })

}

/**
 * 异步promise方法
 * @param {*} options 
 * @returns 
 */
export const requestsAsync =(options) => {
  let url=urls(options.url);
  const shoptoken = localStorage.getItem("hasZhukeLoginShopTokens") || ''
  if(options.url && options.url.indexOf('/Auth/GetZhuKeTokenByShopInfo') > -1 || options.url.indexOf('/Auth/GetZhuKeCommAlibabaByAlone') > -1)
    url = systemConfig.initTokenRequestUrl + options.url
  else if(options.shopType === true)
    url = systemConfig.serverLink() + options.url + '?shopToken=' + shoptoken

  return new Promise((resolve,reject)=>{
    axios.post(url,options.data).then((res) => {
      var dates =res.data;
      resolve(dates)
    }).catch(err=> { 
      if(options.url.indexOf('GetQuickGuideData') > -1){
        reject(err)
      }
      else{//统一使用resolve,
        resolve({ Success:false,Message:err })
      }} 
    )
  })
}

 function urls(url){
  return systemConfig.serverLink() + url +"?pctoken="+zhuKeToken;

 }

 export const getToken=()=>{
  return zhuKeToken;
 }
 export const getZkShopName=()=>{
  return zhuKeShopName;
 }
 export const getLoginShopName=()=>{
  return loginShopName;
 }
 export const getLoginShopInfo=()=>{
  return  {
    loginShopId:loginShopId,
    loginShopName:loginShopName,
    loginShopPlatformType:loginShopPlatformType,
    loginShopPayUrl:loginShopPayUrl,
    loginShopExpiredDay:loginShopExpiredDay
    
  };
 }
 export const getTaoteId=()=>{
    return zhuKeTaoteId;
 }
 export const getLoginOutShopId=()=>{
  return loginOutShopId;
 }
 export const getTaoteShopName=()=>{
  return zhuKeTaoteShopName;
}

 export const loadZhuKeToken=(tokenUrl)=>{
  
  if(loginShopName =="" || loginShopName ==undefined){
    //获取当前登录的店铺名称
    requests({
     url: "/Auth/GetZhuKeTokenByShopInfo",
     data: {token:tokenUrl},
     success: (json) => {
       if(json.Success){
         loginShopName=json.Data.ShopName;
         loginShopId=json.Data.ShopId;
         loginOutShopId=json.Data.ShopOutId;
         loginShopPlatformType=json.Data.PlatformType;
         loginShopExpiredDay=json.Data.ExpiredDay;
         loginShopPayUrl=json.Data.PayUrl;
         systemConfig.platformType = json.Data.PlatformType;
         systemConfig.curShopId = json.Data.ShopId || "";

       }
       if(json.Data.PlatformType == "KuaiShou")
       {
          //快手是双应用有一个是铺货应用一个是采购应用，所以续订的链接也需要调整
          if(funSplitTypeNumber ==0 || funSplitTypeNumber==1)
          {
            funSplitTypeNumber=1;
          }
          if(funSplitTypeNumber==2)
          {
            loginShopPayUrl=json.Data.PayUrlByOrder;
          }
       }
       
     },
     fail: (err) => {}
    })
 }
 
  //获取主客的token
  requests({
    url: "/Auth/GetZhuKeCommAlibabaByAlone",
    data: {token:tokenUrl},
    success: (json) => {
      localStorage.removeItem('home_shop_list')
      if(json.Success){
        var tokens=json.Data.ZhuKeToken;
        var shopName=json.Data.ZhuKeShopName;
        //console.log("tokens:"+tokens);
        zhuKeToken=tokens;
        zhuKeShopName=shopName;
        // systemConfig.zhukeAlibabaAuth = json.Data.ZhukeAlibabaAuth;
        // systemConfig.zhukeTaoteAuth = json.Data.ZhukeTaoteAuth;
        zhuKeTaoteId = json.Data.ZhuKeTaoTeId;
        zhuKeTaoteShopName = json.Data.ZhuKeTaoTeName;

        requests({
          url:'/MyShop/GetSystemUrl',
          success:res =>{
            if(res.Success){
              var urls = res.Data.SystemUrl;
              if (urls) systemConfig.requestUrl = urls;
            }
          }
         })

        requests({
          url:'/Common/GetBuyerShopUserInfo',
          success:res =>{
            if(res.Success){
              var buyerShops = res.Data;
              var taoteZhuKeShop = buyerShops.find(x => x.SourcePlatform == 'TaoteZhuKe')
              var alibabaZhuKeShop = buyerShops.find(x => x.SourcePlatform == 'AlibabaZhuKe')
              if(taoteZhuKeShop){
                systemConfig.zhukeTaoteAuth = taoteZhuKeShop.AuthExpired;
              }
              if(alibabaZhuKeShop){
                systemConfig.zhukeAlibabaAuth = alibabaZhuKeShop.AuthExpired;
                systemConfig.alibabaShopId=alibabaZhuKeShop.AlibabaShopId
              }
            }
          }
        })
      }else{
          if(json.ErrorCode!="NOT_BUYER_SHOP"){
           //console.log(json.Message);
          }

          if(json.Message.indexOf('没有绑定') == -1)
          {
            Message({
              showClose: true,
              message: json.Message,
              type: 'error'
            });
          }
          
      }
    },
    fail: (err) => {
      
      //reject(new {isSuccess:false,'err':err})
    }
  })
 
 }

 //公共提示框   'success', 'warning', 'error', 'notice', 'help', 'loading'
 export const messageShow=function(val,type){
    Message({ message: val, offset: 60, type: type });
 }
  


 export const isNotNull=function(val){
  var isNotNull=true;
  try{
   if(val ==null || val ==undefined || val =="undefined" || val =="")
        isNotNull=false;
     
   //后面还会加其他的判断，更加准确

  }catch (e){} 

  return isNotNull;
}
export const millisecondToDate=function(msd){
  var time = parseFloat(msd) / 1000;
    if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
            time = parseInt(time / 60.0) + "分" + parseInt((parseFloat(time / 60.0) -
                parseInt(time / 60.0)) * 60) + "秒";
        }
        else if (time >= 60 * 60) {
            time = parseInt(time / 3600.0) + "时" + parseInt((parseFloat(time / 3600.0) -
                parseInt(time / 3600.0)) * 60) + "分" +
                parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                    parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        }
        else {
            time = parseInt(time) + "秒";
        }
    }
    return time;
}

export const formatDuration = function(timestamp) {
    let seconds = Math.floor(timestamp / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);
    let result = "";
    if (days > 0) {
        result += days + "天";
    } else {
        result += "0天";
    }
    if (hours > 0) {
        result += (hours % 24) + "小时";
    }
    if (minutes > 0) {
        result += (minutes % 60) + "分";
    }
    if (seconds > 0) {
        result += (seconds % 60) + "秒";
    }
    return result.trim();
}

export const getPlatformName=function(platformType){
  switch(platformType)
  {
      case "Pinduoduo":
          return "拼多多"
      case "TouTiao":
          return "抖音"
      case "KuaiShou":
          return "快手"
      case "Taobao":
          return "淘宝"
      case "WxVideo":
          return "微信视频号"
      case "XiaoHongShu":
          return "小红书"
      case "YouZan":
        return "有赞"
      case "KuaiTuanTuan":
        return "快团团"
      case "WeiMeng":
        return "微盟"
  }
  return platformType
}

export const addDays = function(date, days) {
    var result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
}
 
export const formatDate = function(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; // 月份是从0开始的
    var y = date.getFullYear();
    return y + '-' + (m<10 ? '0'+m : m) + '-' + (d < 10 ? '0'+d : d);
}


//图片前缀(暂时用不上)
export const imgUrl='https://pddmobile.dgjapp.com/'

export const matchSupplierProduct = (source) => {
  //支持匹配货源商品Id
  var regexForm1688 = /((http|https):\/\/)?(www)?detail.1688.com\/offer\/\d+(.html)?/g;
  var regexFormTaote = /(http|https):\/\/u.ltao.com[^\s\u4e00-\u9fa5]*/g;
  var regexFormTaoteSource = /((http|https):\/\/market.m.taobao.com\/app\/nozomi\/app-h5-detail\/main\/index.html\?id=\d+|(http|https):\/\/market.m.taobao.com\/app\/ltao-fe\/ltao-lite\/productdetail.html\?ft=t&id=\d+|(http|https):\/\/item.taobao.com\/item.htm\?[\S]*id=\d+)/g;
  var match1688 = source.match(regexForm1688);
  var matchTaote = source.match(regexFormTaote);
  var matchTaoteSource = source.match(regexFormTaoteSource);
  const supplierProductLinks = [];

  if (match1688) 
  {
      var matchSupplierIdReg = /offer\/\d+/;
      match1688.forEach(link => {
          var supplierProductIds = matchSupplierIdReg.exec(link)
          if (supplierProductIds.length > 0) {
              supplierProductLinks.push({
                  link: link,
                  supplierProductId: supplierProductIds[0].replace('offer/', ''),
                  sourcePlatform:"AlibabaZhuKe"
              })
          }
      })
  }
  // if(matchTaote)
  // {
  //   matchTaote.forEach(link => {
  //       supplierProductLinks.push({
  //           link: link,
  //           sourcePlatform:"TaoteZhuKe"
  //       })
  //   })
  // }
  // if(matchTaoteSource)
  // {
  //   var matchSupplierIdReg = /id=\d+/;
  //   matchTaoteSource.forEach(link => {
  //     var supplierProductIds = matchSupplierIdReg.exec(link)
  //     supplierProductLinks.push({
  //         link: link,
  //         supplierProductId: supplierProductIds[0].replace('id=', ''),
  //         sourcePlatform:"TaoteZhuKe"
  //     })
  // })
  // }

  return supplierProductLinks;
}
export const matchSupplierProductV2 = (urlStr) => {
  //支持匹配货源商品Id
  const regexForm1688 = /((http|https):\/\/)?(www)?detail.1688.com\/offer\/\d+(.html)?/g;
  const regexFormTaote = /(http|https):\/\/u.ltao.com[^\s\u4e00-\u9fa5]*/g;
  const regexFormTaoteSource = /((http|https):\/\/market.m.taobao.com\/app\/nozomi\/app-h5-detail\/main\/index.html\?id=\d+|(http|https):\/\/market.m.taobao.com\/app\/ltao-fe\/ltao-lite\/productdetail.html\?ft=t&id=\d+|(http|https):\/\/item.taobao.com\/item.htm\?[\S]*id=\d+)/g;
  
  const supplierProductLinks = [];
  const errorLink = [];//
  const regexFromUrl = /(http|https):\/\/\S+/g;
  const matchUrl = urlStr.match(regexFromUrl)

  if(matchUrl){
    matchUrl.forEach(source => {
      const match1688 = source.match(regexForm1688);
      const matchTaote = source.match(regexFormTaote);
      const matchTaoteSource = source.match(regexFormTaoteSource);
      if (match1688) 
      {
          var matchSupplierIdReg = /offer\/\d+/;
          match1688.forEach(link => {
              var supplierProductIds = matchSupplierIdReg.exec(link)
              if (supplierProductIds.length > 0) {
                  supplierProductLinks.push({
                      link: link,
                      supplierProductId: supplierProductIds[0].replace('offer/', ''),
                      sourcePlatform:"AlibabaZhuKe"
                  })
              }
          })
      }
      // if(matchTaote)
      // {
      //   matchTaote.forEach(link => {
      //       supplierProductLinks.push({
      //           link: link,
      //           sourcePlatform:"TaoteZhuKe"
      //       })
      //   })
      // }
      // if(matchTaoteSource)
      // {
      //   var matchSupplierIdReg = /id=\d+/;
      //   matchTaoteSource.forEach(link => {
      //     var supplierProductIds = matchSupplierIdReg.exec(link)
      //     supplierProductLinks.push({
      //         link: link,
      //         supplierProductId: supplierProductIds[0].replace('id=', ''),
      //         sourcePlatform:"TaoteZhuKe"
      //     })
      // })
      // }
      if(!match1688 && !matchTaote && !matchTaoteSource){
        errorLink.push(source)
      }
    })
  }

  return {supplierProductLinks,errorLink};
}

//跳转商品编辑页
export const toProductEditPage = (item) =>
{
  let toUrl = "";
  if(item.PlatformType =="XiaoHongShu")
    toUrl = 'https://ark.xiaohongshu.com/app-item/good/edit/'+item.PlatformId
  else if(item.PlatformType == "TouTiao")
    toUrl = 'https://fxg.jinritemai.com/ffa/g/create?product_id='+item.PlatformId
  else if(item.PlatformType == "Taobao")
    toUrl = 'https://item.upload.taobao.com/sell/v2/publish.htm?itemId='+item.PlatformId
  else if(item.PlatformType == "Pinduoduo")
    toUrl = 'https://mms.pinduoduo.com/goods/goods_detail?goods_id='+item.PlatformId
  else if(item.PlatformType == "KuaiShou")
     toUrl = 'https://s.kwaixiaodian.com/zone/goods/config/release/edit/ordinary?itemId='+item.PlatformId
  else if(item.PlatformType == "WxVideo")
    toUrl = 'https://channels.weixin.qq.com/shop/goods/entry?productId='+item.PlatformId
  else if(item.PlatformType == "YouZan")
    toUrl = 'https://shangjia.youzan.com/v4/goods/edit?#/id='+item.PlatformId


  window.open(toUrl, "_blank");
}

// export const funSplitType=1;   // 0 没有拆分  1为铺货助手  2为采购下单 


 // 0 没有拆分  1为铺货助手  2为采购下单 
export const funSplitType=()=>{
  return funSplitTypeNumber;
} 

// 是否加载过系统
export const isLoadSystem=()=>{
  return isLoadSystemData;
}  

export const loadSysTem=function(){
  isLoadSystemData=true;
}

//防抖函数
const debounceOther = (func, wait = 800) =>{
  let timeout; // 定时器变量
  return function (...args) {
    clearTimeout(timeout); // 每次触发时先清除上一次的定时器,然后重新计时
    timeout = setTimeout(() => {
      func(...args);
    }, wait); // 指定 xx ms 后触发真正想进行的操作 handler
  };
};
const fromClassName = (obj) =>{
  if(!obj) return null;
    const keys = Object.keys(obj);
    let classNames = []
    for(let field of keys){
      if(obj[field]){
        classNames.push(field)
      }
    }
    return classNames.join(' ')
}
export { debounceOther,fromClassName }

export const requestExternal=(options)=>{
  if(((options.type?options.type:"").toLowerCase()=="post")){
    return axios.post(options.url,options.data?options.data:"").then((res) => {
      var dates =res.data;
      options.success(dates)
    }).catch(err=> {
      if(typeof options.fail=="function"){
        options.fail(err)
      }
    })
  }else{
    let params="";
    if(options.data){

    }
    return axios.get(options.url,{params:(options.data?options.data:{})}).then((res) => {
      var dates =res.data;
      options.success(dates)
    }).catch(err=> {
      if(typeof options.fail=="function"){
        options.fail(err)
      }
    })
  }
}





// WEBPACK FOOTER //
// ./src/utils/http.js